import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const ExternalOffers = () => {
  const { authFetch } = useContext(AuthContext);

  const [offers, setOffers] = useState([]);
  const [filteredOffers, setFilteredOffers] = useState([]);

  const [search, setSearch] = useState("");
  const [filterArea, setFilterArea] = useState("");
  const [filterContract, setFilterContract] = useState("");
  const [filterPlace, setFilterPlace] = useState("");

  const [loading, setLoading] = useState(true);
  const [areas, setAreas] = useState([]);


  // PAGINACIÓN
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // MODAL
  const [showModal, setShowModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);

  // Alertas
  const [alert, setAlert] = useState({ type: "", msg: "" });

  // Evitar doble click
  const [isApplying, setIsApplying] = useState(false);

  // =============================
  // 🟦 Mostrar alertas: 3 segundos
  // =============================
  const showAlert = (type, msg) => {
    setAlert({ type, msg });

    setTimeout(() => {
      setAlert({ type: "", msg: "" });
    }, 3000);
  };

  // =============================
  // 🟦 Cargar ofertas
  // =============================
  const loadOffers = useCallback(async () => {
    try {
      const res = await authFetch(ENDPOINTS.getOffers);

      if (res.success && Array.isArray(res.offers)) {
        setOffers(res.offers);
        setFilteredOffers(res.offers);
      } else {
        setOffers([]);
        setFilteredOffers([]);
      }
    } catch (err) {
      console.error("Error cargando ofertas:", err);
    }

    setLoading(false);
  }, [authFetch]);

  useEffect(() => {
    loadOffers();
  }, [loadOffers]);

  // =============================
  // 🟩 Filtros
  // =============================
  useEffect(() => {
    let temp = [...offers];

    if (search.trim() !== "") {
      temp = temp.filter((o) =>
        o.professional_program?.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (filterArea !== "") temp = temp.filter((o) => o.area === filterArea);
    if (filterContract !== "")
      temp = temp.filter((o) => o.type_contract === filterContract);
    if (filterPlace !== "") temp = temp.filter((o) => o.place === filterPlace);

    setFilteredOffers(temp);
    setCurrentPage(1);
  }, [search, filterArea, filterContract, filterPlace, offers]);

  // =============================
  // 🟦 CREAR POSTULACIÓN
  // =============================
  const createPostulation = async () => {
    setIsApplying(true);

    try {
      const res = await authFetch(ENDPOINTS.createPostulation, {
        method: "POST",
        body: JSON.stringify({
          IdOfertas: selectedOffer.IdOfertas,
        }),
      });

      // Cerrar el modal SIEMPRE
      closeModal();

      if (res.success) {
        showAlert("success", "¡Te has postulado exitosamente!");
      } else {
        showAlert("danger", res.message);
      }
    } catch (err) {
      console.error(err);
      closeModal();
      showAlert("danger", "Error al enviar la postulación.");
    }

    setIsApplying(false);
  };

  useEffect(() => {
  const fetchAreas = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getarea, {
        method: "GET"
      });

      if (res.success) {
        setAreas(res.data);
      }
    } catch (err) {
      console.error("Error cargando áreas:", err);
    }
  };

  fetchAreas();
}, [authFetch]);


  // =============================
  // 🟦 Modal
  // =============================
  const openModal = (offer) => {
    setSelectedOffer(offer);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedOffer(null);
  };

  // PAGINACIÓN
  const last = currentPage * itemsPerPage;
  const first = last - itemsPerPage;
  const pageData = filteredOffers.slice(first, last);
  const totalPages = Math.ceil(filteredOffers.length / itemsPerPage);

  return (
    <div className="container p-4">

      {/* ============================
          ALERTA FIJA ARRIBA
      ============================ */}
      {alert.msg && (
        <div className={`alert alert-${alert.type} text-center`} role="alert">
          {alert.msg}
        </div>
      )}

      <h2 className="text-center mt-3 fw-bold">OFERTAS LABORALES DISPONIBLES</h2>
      <p className="text-center">PRESENCIA COLOMBO SUIZA</p>

      {/* FILTROS */}
      <div className="card p-3 mb-4 shadow-sm">
        <div className="row g-3">
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por programa..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <select
                className="form-select"
                value={filterArea}
                onChange={(e) => setFilterArea(e.target.value)}
              >
                <option value="">Área (todas)</option>

                {areas.map((area) => (
                  <option key={area.id_area} value={area.id_area}>
                    {area.name}
                  </option>
                ))}
              </select>

          </div>

          <div className="col-md-3">
            <select
              className="form-select"
              value={filterContract}
              onChange={(e) => setFilterContract(e.target.value)}
            >
              <option value="">Contrato (todos)</option>
              <option value="Fijo">Fijo</option>
              <option value="Indefinido">Indefinido</option>
              <option value="Obra labor">Obra labor</option>
              <option value="Prestacion de servicio">Prestación de servicios</option>
            </select>
          </div>

          <div className="col-md-2">
            <select
              className="form-select"
              value={filterPlace}
              onChange={(e) => setFilterPlace(e.target.value)}
            >
              <option value="">Lugar</option>
              <option value="Medellin">Medellín</option>
              <option value="Robledo">Robledo</option>
              <option value="Bello">Bello</option>
            </select>
          </div>
        </div>
      </div>

      {/* TARJETAS */}
      {loading ? (
        <p className="text-center">Cargando ofertas...</p>
      ) : (
        <div className="row g-4">
          {pageData.length === 0 ? (
            <p className="text-center">No hay ofertas con estos filtros.</p>
          ) : (
            pageData.map((offer) => (
              <div className="col-md-4" key={offer.IdOfertas}>
                <div className="card shadow-sm h-100 p-3">
                  <h5 className="mb-2">{offer.professional_program}</h5>

                  <span className="badge bg-secondary mb-2">{offer.area_name}</span>

                  <p><strong>Contrato:</strong> {offer.type_contract}</p>
                  <p><strong>Duración:</strong> {offer.duration}</p>
                  <p><strong>Lugar:</strong> {offer.place}</p>

              <p className="fw-bold text-success mt-2 fs-5"> 
                {offer.salary && offer.salary !== ""
                  ? Number(offer.salary).toLocaleString("es-CO", {
                      style: "currency",
                      currency: "COP",
                      minimumFractionDigits: 0,
                    })
                  : "$ A convenir"}
              </p>

                  <button
                    className="btn btn-outline-pink mt-auto"
                    onClick={() => openModal(offer)}
                  >
                    Ver detalles
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {/* PAGINACIÓN */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4 align-items-center">
          <button
            className="btn btn-outline-secondary mx-1"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            <i class="bi bi-caret-left-fill"></i>
          </button>
          <span className="px-3 py-2">
            Página {currentPage} de {totalPages}
          </span>
          <button
            className="btn btn-outline-secondary mx-1"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            <i class="bi bi-caret-right-fill"></i>
          </button>
        </div>
      )}

      {/* MODAL */}
      {showModal && selectedOffer && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">

              <div className="modal-header">
                <h3 className="modal-title">
                  {selectedOffer.professional_program}
                </h3>
                <button className="btn-close" onClick={closeModal}></button>
              </div>

              <div className="modal-body">
                <p className="fst-italic">{selectedOffer.area_name}</p>

                <div className="row">
                  <div className="col-6">
                    <p><b>Contrato:</b> {selectedOffer.type_contract}</p>
                  </div>
                  <div className="col-6">
                    <p><b>Duración:</b> {selectedOffer.duration}</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-6">
                    <p><b>Lugar:</b> {selectedOffer.place}</p>
                  </div>
                  <div className="col-6">
                    <p>
                      <b>Salario:</b>{" "}
                      {Number(selectedOffer.salary).toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                        minimumFractionDigits: 0,
                      })}
                    </p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-6">
                    <p><b>Educación minima:</b> {selectedOffer.minimum_education}</p>
                  </div>
                  <div className="col-6">
                    <p>
                      <b>Experience:</b> {selectedOffer.experience}
                    </p>
                  </div>
                </div>

                
                  {selectedOffer.curso_altura === "Si" && (
                    <p>
                      <b>Curso de altura:</b> Sí
                    </p>
                  )}
                  {selectedOffer.curso_manipulacion_alimento === "Si" && (
                    <p>
                      <b>Curso de manipulación de alimentos:</b> Sí
                    </p>
                  )}
                  {selectedOffer.professional_card === "Si" && (
                    <p>
                      <b>Tarjeta profesional:</b> Sí
                    </p>
                  )}

                <hr />
                <p><strong>Descripción:</strong></p>
                <p>{selectedOffer.functions || "Sin descripción disponible."}</p>
              </div>

              <div className="modal-footer d-flex justify-content-between">
                <small className="m-0">
                  <b>Publicado:</b>{" "}
                  {new Date(selectedOffer.created_at).toLocaleDateString("es-CO")}
                </small>

                <button
                  className="btn btn-outline-pink"
                  disabled={isApplying}
                  onClick={createPostulation}
                >
                  {isApplying ? "Enviando..." : "Aplicar a esta oferta"}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ExternalOffers;
